import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  HOME_ADD_LAST_ACCESS_BEGIN,
  HOME_ADD_LAST_ACCESS_SUCCESS,
  HOME_ADD_LAST_ACCESS_FAILURE,
  HOME_ADD_LAST_ACCESS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import cookie from 'react-cookies';
export function addLastAccess(args = {}) {
  return (dispatch) => {
    dispatch({
      type: HOME_ADD_LAST_ACCESS_BEGIN,
    });
    const { projectId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}projects/core/${projectId}/last-access`,
        {},
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: HOME_ADD_LAST_ACCESS_SUCCESS,
            data: res,
          });
          const expires = new Date(Date.now() + 86400000);
          cookie.save('lastAccess', true, { expires });
          console.log('last access added builder surface');
          resolve(res);
        },
        (err) => {
          dispatch({
            type: HOME_ADD_LAST_ACCESS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissAddLastAccessError() {
  return {
    type: HOME_ADD_LAST_ACCESS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_ADD_LAST_ACCESS_BEGIN:
      return {
        ...state,
        addLastAccessPending: true,
        addLastAccessError: null,
      };

    case HOME_ADD_LAST_ACCESS_SUCCESS:
      return {
        ...state,
        addLastAccessPending: false,
        addLastAccessError: null,
      };

    case HOME_ADD_LAST_ACCESS_FAILURE:
      return {
        ...state,
        addLastAccessPending: false,
        addLastAccessError: action.data.error,
      };

    case HOME_ADD_LAST_ACCESS_DISMISS_ERROR:
      return {
        ...state,
        addLastAccessError: null,
      };

    default:
      return state;
  }
}
